"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmList = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const SmListItem_1 = require("./SmListItem");
exports.SmList = react_1.default.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const listClassNames = (0, classnames_1.default)('c-list', props.className);
    return (react_1.default.createElement("ul", Object.assign({}, props, { className: listClassNames, ref: ref }), children));
});
exports.SmList.Item = SmListItem_1.SmListItem;
//# sourceMappingURL=index.js.map